







































import {
  FilaMensagem,
  FilaMensagensService,
} from "@/services/fila-mensagens.service";
import { ProcessamentoFilaMensagensService } from "@/services/processamentoFilaMensagem.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Loading,
    Modal,
  },
})
export default class Manter extends Vue {
  txtFormatoJson: string | null = null;
  valid = false;
  loading = false;
  erroDescricao = false;
  show = false;
  showErro = false;
  fila: FilaMensagem | null = null;

  rules = {
    titulo: [required()],
    idTipoNotificacao: [required()],
    descricao: [required()],
  };

  mounted() {
    const params = this.$route.params;
    const idFilaMensagem = params.idFilaMensagem;
    const idConsultor = +params.idConsultor;

    this.loading = true;
    FilaMensagensService.Obter(idConsultor, idFilaMensagem)
      .then((fila) => (this.fila = fila))
      .then((fila) => this.formatoJson(fila))
      .finally(() => (this.loading = false));
  }

  get tituloManter(): string {
    return "Formato Json";
  }

  get podeIniciarProcessamento(): boolean {
    return (
      !!this.fila &&
      (this.fila.tipoMensagem == 4 || this.fila.tipoMensagem == 3)
    );
  }

  public async formatoJson(filaMensagem: FilaMensagem) {
    this.txtFormatoJson = "";
    try {
      const obj = JSON.parse(filaMensagem.mensagem);
      this.txtFormatoJson = JSON.stringify(obj, null, 4);
    } catch {
      this.showErro = true;
      setTimeout(this.fechaAlerta, 5000);
    }
  }

  copiarMensagem() {
    const mensagemCopiada = document.getElementById(
      "mensagem"
    ) as HTMLInputElement;
    if (this.txtFormatoJson) {
      mensagemCopiada.select();
      document.execCommand("copy");
    }

    this.show = true;
    setTimeout(this.fechaAlerta, 5000);
  }

  fechaAlerta() {
    this.show = false;
    this.showErro = false;
  }

  fechar() {
    this.$router.go(-1);
  }

  iniciarProcessamento() {
    const params = this.$route.params;
    const idFilaMensagem = params.idFilaMensagem;
    const idConsultor = +params.idConsultor;
    this.loading = true;

    ProcessamentoFilaMensagensService.gerarProcessamento(
      idConsultor,
      idFilaMensagem
    )
      .then((idProcessamentoFilaMensagem) => {
        this.$router.replace({
          name: "processarfilamensagem",
          params: { ...this.$route.params, idProcessamentoFilaMensagem },
        });
      })
      .finally(() => (this.loading = false));
  }
}
